"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterInactiveWebVitals = exports.addFixedMetricEventDetail = void 0;
/* eslint-disable no-param-reassign */
const events_1 = require("../constants/events");
const webVitals_1 = require("../constants/webVitals");
const { CLS: CLSName, TTFB: TTFBName } = events_1.EVENT_NAMES.WEB_VITALS;
// >>> START PERF-777 >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
/**
 * Insert an event detail object for a "fixed" metric, i.e., CLSFixed,
 * TTFBFixed, into the given `eventDetails` array just after the event detail of
 * the original metric.
 */
const addFixedMetricEventDetail = (eventDetails, metricName, metricFixedName) => {
    const metricEventDetail = webVitals_1.WEB_VITALS_EVENT_DETAILS.find(eventDetail => Object.keys(eventDetail)[0] === metricName);
    const metricFixedEventDetail = {
        [metricFixedName]: Object.assign(Object.assign({}, metricEventDetail[metricName]), { graphiteName: metricFixedName }),
    };
    const metricEventDetailIdx = eventDetails.findIndex(eventDetail => Object.keys(eventDetail)[0] === metricName);
    // Insert the new fixed metric event detail object next to the old
    // one for better visibility
    eventDetails.splice(metricEventDetailIdx + 1, 0, metricFixedEventDetail);
};
exports.addFixedMetricEventDetail = addFixedMetricEventDetail;
// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< END PERF-777 <<<
/**
 * Filter function to keep all non-Web Vitals event details and event details
 * for active Web Vitals metrics.
 * @private
 */
const filterInactiveWebVitals = eventDetail => {
    const eventName = Object.keys(eventDetail)[0];
    const isWebVitalsMetric = webVitals_1.WEB_VITALS.includes(eventName);
    const isActiveWebVitalsMetric = webVitals_1.ACTIVE_WEB_VITALS.includes(eventName);
    const keepEventDetail = !isWebVitalsMetric || isActiveWebVitalsMetric;
    // >>> START PERF-777 >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // Always add CLS and TTFB event details even if they're not supported by
    // the browser to match legacy behavior (so we don't break existing
    // monitoring)
    if ([CLSName, TTFBName].includes(eventName))
        return true;
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< END PERF-777 <<<
    return keepEventDetail;
};
exports.filterInactiveWebVitals = filterInactiveWebVitals;
/**
 * Remove event details for Web Vitals metrics not supported by the browser from
 * a given `appConfig` IN-PLACE.
 *
 * @warning This function mutates the `appConfig` object.
 * @todo Register via `registerEvent()`. See PERF-836.
 */
const rmInactiveWebVitalsEventDetails = appConfig => {
    const { eventDetails } = appConfig.trackedEventDetails;
    const filteredEventDetails = eventDetails.filter(filterInactiveWebVitals);
    // >>> START PERF-777 >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // If CLS or TTFB _are_ supported by the browser, add new separate event
    // details for the corrected values (so we can compare the old and new
    // values before replacing them.)
    [CLSName, TTFBName].forEach(metricName => {
        if (webVitals_1.ACTIVE_WEB_VITALS.includes(metricName)) {
            addFixedMetricEventDetail(filteredEventDetails, metricName, events_1.EVENT_NAMES.WEB_VITALS[`${metricName}Fixed`]);
        }
    });
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< END PERF-777 <<<
    appConfig.trackedEventDetails.eventDetails = filteredEventDetails;
    return appConfig;
};
exports.default = rmInactiveWebVitalsEventDetails;
